export default __webpack_public_path__ + "static/media/dishwashings.2c7771e3.png";